import React from 'react'
import HalfStepNumberInput from 'ui-shared/WrappedInputs/HalfStepNumberInput'

const LocationTimeSuggestionsInput: React.FC = () => {
  return (
    <div>
      <HalfStepNumberInput
        source="defaultHoursBefore"
        label="form.fields.defaultHoursBefore"
      />
      <br />
      <HalfStepNumberInput
        source="defaultHoursAfter"
        label="form.fields.defaultHoursAfter"
      />
    </div>
  )
}

export default LocationTimeSuggestionsInput
